<template>
    <div id="internationalDetail" class="ui-tabs-content">
        <div class="region-title">
            <h3>{{ _ll('国家') }}</h3>
        </div>
        <div id="international-list" class="region-list">
            <swiper :options="options" class="region-swiper">
                <swiper-slide v-for="intern in internationalList" v-show="internationalList" :key="intern.code" class="region-swiper-slide">
                    <div :id="intern.code" class="region-item" :class="{ cur: curCountry.code === intern.code }" @click="countryClick(intern)">
                        {{ intern.name }}
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    name: 'InterArea',
    components: {
        swiper,
        swiperSlide
    },
    props: {
        internationalList: {
            type: Array,
            defaultValue: []
        },
        fromAddrObj: {
            selectCode: {
                type: String,
                defaultValue: ''
            }
        }
    },
    data() {
        return {
            selectedLi: {},
            curCountry: {},
            options: {
                direction: 'vertical',
                slidesPerColumn: 3,
                slidesPerView: 3
            }
        }
    },
    watch: {
        internationalList: function (interList) {
            if (interList && interList.length > 0) {
                const countryData = interList.find(value => value.code === this.fromAddrObj.selectCode)
                if (countryData) {
                    this.curCountry = countryData
                    this.$emit('receiveData', countryData, null, null, false)
                }
            }
        }
    },
    activated: function () {
        if (this.internationalList.length > 0) {
            const country = this.internationalList.find(value => value.code === this.fromAddrObj.selectCode)
            if (country) {
                this.curCountry = country
            }
            if (this.curCountry.code) {
                this.$emit('receiveData', this.curCountry, {}, {}, false)
            } else {
                this.$emit('receiveData', this.curCountry, {}, {}, true)
            }
        } else {
            this.$emit('receiveData', null, null, null, true)
        }
    },
    methods: {
        countryClick: function (country) {
            if (this.curCountry.code === country.code) {
                this.curCountry = {}
                this.$emit('receiveData', null, null, null, true)
            } else {
                this.curCountry = country
                this.$emit('receiveData', country, null, null, false)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.region-title {
    height: 100px;
    line-height: 100px;
    padding-left: 20px;
    border-top: 1px solid $gray-dark;
}

.region-list .cur {
    background-color: $red;
}

.region-item {
    display: block;
    color: $white;
    text-align: center;
    height: 70px;
    line-height: 70px;
}
.region-swiper {
    height: 210px;
}
.region-swiper-slide {
    width: 33.3333%;
}
</style>



// WEBPACK FOOTER //
// src/components/region/inter-area.vue